__turbopack_context__.v({
  "container": "yecegq_container",
  "placeholderWrapper": "yecegq_placeholderWrapper",
});
